import { Badge } from "../ui/badge";
import { Button } from "../ui/button";
import { EmptyState } from "../EmptyState";
import { FileText, Sparkles } from "lucide-react";

export const STATUS_STYLE = {
  submetida: "bg-slate-100 text-slate-700",
  em_analise: "bg-blue-100 text-blue-700",
  entrevista: "bg-amber-100 text-amber-700",
  aceite: "bg-emerald-100 text-emerald-700",
  rejeitada: "bg-red-100 text-red-700",
};

export const STATUS_LABEL = {
  submetida: "Submetida",
  em_analise: "Em análise",
  entrevista: "Entrevista",
  aceite: "Aceite",
  rejeitada: "Rejeitada",
};

/** Lista de candidaturas do candidato, com o botão de carta de motivação por IA. */
export const ApplicationsList = ({ apps, generatingLetter, onOpenLetter, onOpenJob, onBrowseJobs }) => {
  if (apps.length === 0) {
    return (
      <EmptyState icon={FileText} title="Ainda sem candidaturas"
        description="Procura vagas e candidata-te em minutos."
        actionLabel="Procurar empregos" onAction={onBrowseJobs} />
    );
  }
  return (
    <div className="space-y-3">
      {apps.map((a) => (
        <div key={a.id} data-testid={`application-row-${a.id}`} className="bg-white rounded-xl border border-black/5 p-5">
          <div className="flex flex-wrap items-center justify-between gap-3">
            <div>
              <p className="font-heading font-bold tracking-tighter text-slate-900 cursor-pointer hover:underline"
                onClick={() => onOpenJob(a.job_slug)}>{a.job_title}</p>
              <p className="text-sm text-slate-500">
                {a.company_name} · {new Date(a.created_at).toLocaleDateString("pt-PT")}
              </p>
            </div>
            <Badge data-testid={`application-status-${a.id}`} className={`${STATUS_STYLE[a.status]} hover:${STATUS_STYLE[a.status]}`}>
              {STATUS_LABEL[a.status]}
            </Badge>
          </div>
          <div className="flex items-center gap-2 mt-3 pt-3 border-t border-black/5">
            <Button
              data-testid={`cover-letter-btn-${a.id}`}
              size="sm" variant="outline"
              className={`rounded-full ${a.cover_letter ? "border-emerald-400 text-emerald-700 hover:bg-emerald-50" : "border-amber-400 text-amber-600 hover:bg-amber-50"}`}
              disabled={generatingLetter === a.id}
              onClick={() => onOpenLetter(a)}>
              <Sparkles className="w-3.5 h-3.5 mr-1.5" />
              {generatingLetter === a.id ? "A gerar..." : a.cover_letter ? "Ver carta IA" : "Gerar carta IA"}
            </Button>
          </div>
        </div>
      ))}
    </div>
  );
};
